import React from 'react';

import { gql, useQuery, type QueryHookOptions } from '@apollo/client';

export type Cashback = {
  id: string;
  amount: number;
  expiredAt?: string | Date | null;
  usedAt?: string | Date | null;
  restaurant?: {
    id: string;
  };
};

type QueryData = {
  user?: {
    restaurant?: {
      id: string;
      cashbacks?: Cashback[] | null;
    } | null;
  };
};

type QueryVars = {
  restaurantId: string;
};

const getRestaurantCashbacksGql = gql(`
  query getRestaurantCashbacks($restaurantId: ID!) {
    user {
      restaurant(id: $restaurantId) {
        id
        cashbacks {
          id
          amount
          expiredAt
          usedAt
          restaurant {
            id
          }
        }
      }
    }
  }
`);

const useRestaurantCashbacks = (
  restaurantId?: string | null,
  options?: Omit<QueryHookOptions<QueryData, QueryVars>, 'variables'>,
) => {
  const { data, loading, refetch } = useQuery<QueryData, QueryVars>(getRestaurantCashbacksGql, {
    skip: !restaurantId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    ...options,
    variables: { restaurantId: restaurantId as string },
  });

  const cashbacks: Cashback[] = React.useMemo(
    () => data?.user?.restaurant?.cashbacks ?? [],
    [data?.user?.restaurant?.cashbacks],
  );

  return { cashbacks, loading, refetch };
};

export default useRestaurantCashbacks;
